import React from 'react';
import { motion } from 'framer-motion';
import { trackCTAClick } from '../utils/metaPixel';
export function EmpathyStory() {
  const checkoutUrl = 'https://yennilemon.com/cart/44434972934279:1?country=US&locale=es';
  return <section className="bg-[#F5EFE6] py-16 md:py-24 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-49">
          <span className="text-sage font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-50">
            ¿Te identificas?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-51">
            Sabemos lo que estás sintiendo
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lg text-warm-gray leading-relaxed" data-id="element-52">
          <p data-id="element-53">
            Te acuestas cansada, pero en cuanto tocas la almohada, tu mente se
            enciende. O peor aún, logras dormirte pero te despiertas de
            madrugada y ya no puedes volver a cerrar los ojos.
          </p>
          <p data-id="element-54">
            Amaneces sintiendo que te pasó un camión por encima. Te miras al
            espejo y notas el cansancio acumulado. Y lo peor es que no entiendes
            por qué tu cuerpo ya no descansa como antes.
          </p>

          <div className="my-10 pl-6 md:pl-8 border-l-4 border-sage py-2" data-id="element-55">
            <p className="text-xl md:text-2xl font-heading font-medium text-olive italic leading-snug" data-id="element-56">
              "Si estoy tan agotada todo el día... ¿por qué mi cuerpo no me deja
              dormir en la noche?"
            </p>
          </div>

          <p className="font-medium text-olive" data-id="element-57">
            No estás haciendo nada mal. Tu cuerpo simplemente cambió, tus
            hormonas están fluctuando, y necesitas una nueva manera de ayudarlo
            a relajarse.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-58">
          <a href={checkoutUrl} onClick={trackCTAClick} className="inline-block bg-olive hover:bg-olive-light text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-[1.02] shadow-md text-lg" data-id="element-59">
            SÍ, QUIERO DORMIR MEJOR POR $6.39
          </a>
        </motion.div>
      </div>
    </section>;
}